import React from 'react';

export default function Figure({ caption = '', children }) {
  return (
    <figure className="figure">
      {children}
      {caption && caption.trim() !== '' && (
        <figcaption className="figure-caption">{caption}</figcaption>
      )}
    </figure>
  );
}


